import 'App.css'
import './CollapsedHours.css'

import ToggleSectionButton from 'components/ToggleSectionButton'
import PropTypes from 'prop-types'
import React from 'react'
import { noop } from 'utils'

import { formatHour } from './utils'

function CollapsedHours({ fromHour, isCollapsed, onClick, toHour }) {
  return isCollapsed ? (
    <div className="collapsed-hours">
      <ToggleSectionButton isCollapsed={isCollapsed} onClick={onClick} />
      <div className="collapsed-hours-hour">
        {formatHour(fromHour)} - {formatHour(toHour)}
      </div>
    </div>
  ) : null
}

CollapsedHours.defaultProps = {
  onClick: noop,
  fromHour: 0,
  toHour: 8,
}

CollapsedHours.propTypes = {
  fromHour: PropTypes.number,
  isCollapsed: PropTypes.bool,
  onClick: PropTypes.func,
  toHour: PropTypes.number,
}

export default CollapsedHours
